// extracted by mini-css-extract-plugin
module.exports = {"box":"Precautions_box__3KXHV","title":"Precautions_title__tzGSH","desc":"Precautions_desc__3nRxU","content":"Precautions_content__1lIBx"};